import React from 'react';
import * as ReactDOM from 'react-dom/client';
import {createPortal} from 'react-dom';
import {App} from '../app';
import {designerDataMessageBuffer} from '@packages/systems/designer/canvas';

declare global {
  interface Window {
    /**
     * If set indicates that plugins are run inside the Designer App.
     * `true` anywhere in Designer App except preview mode where it is set to `false`.
     */
    __wf_design?: boolean;
    /**
     * In the packages/shared/render/plugins/Widget/webflow-maps.js we are reading value for googleMapsApiKey from the global variables,
     * so we need to ensure that it is available as a global variable
     */
    GOOGLE_MAPS_API_KEY: string;
  }
}

window.__wf_design = false;
window.GOOGLE_MAPS_API_KEY = '';

const MountCanvasApp = () => {
  const [portalTarget, setPortalTarget] =
    React.useState<React.ReactPortal | null>(null);

  const initialRoot = window.document.getElementById(
    'canvas-app-initial-mount-point'
  );
  initialRoot?.remove();

  if (!portalTarget) {
    const portal = createPortal(<App />, window.document.documentElement);
    setPortalTarget(portal);
  }

  return portalTarget;
};

// The Designer starts posting project data on the iframe `load` event, which
// can fire before React has run the effect that subscribes to those messages.
// Buffer them from module evaluation time so the first burst is never lost.
designerDataMessageBuffer.install();

const root = ReactDOM.createRoot(
  document.getElementById('canvas-app-initial-mount-point') as HTMLElement
);

root.render(<MountCanvasApp />);
